export function prevent_default(e: Event) {
    e.preventDefault();
}

export function absorb_event(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}

type PointerEventType =
    | 'pointerover'
    | 'pointerenter'
    | 'pointerdown'
    | 'pointermove'
    | 'pointerup'
    | 'pointercancel'
    | 'pointerout'
    | 'pointerleave'
    | 'gotpointercapture';

export const clone_pointer_event = (x: PointerEvent): PointerEvent => new PointerEvent(x.type, {
    clientX: x.clientX,
    clientY: x.clientY,
    pointerId: x.pointerId,
    pointerType: x.pointerType,
});

export const change_pointer_event_type = (x: PointerEvent, type: PointerEventType) => new PointerEvent(type, {
    clientX: x.clientX,
    clientY: x.clientY,
    pointerId: x.pointerId,
    pointerType: x.pointerType,
});
